module.exports = __webpack_public_path__ + "static/img/6.05d70ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/6.jpg
// module id = 5aUI
// module chunks = 16